import isNull from 'lodash/isNull'
import isUndefined from 'lodash/isUndefined'
import { createMiddleware } from 'reacticoon/middleware'
import { redirectTo } from 'reacticoon/routing'
import { postLogin } from './actions'
import { saveSession, setMfaLoggingUserId } from 'modules/auth/config'

export const onLoginSucceedMiddleware = createMiddleware(
  'App::LoginModule::onLoginSucceedMiddleware',
  postLogin.SUCCESS,
  ({ action, dispatch }) => {
    if (isNull(action.response.mfaEnabled) || isUndefined(action.response.mfaEnabled)) {
      redirectTo('LOGIN')
    }

    if (action.response.mfaEnabled) {
      // If MFA is enabled, set the user ID for MFA logging and redirect to MFA page
      setMfaLoggingUserId(action.response.userId)
      dispatch(redirectTo('LOGIN_MFA'))
    } else {
      // If MFA is not enabled, redirect to the home page
      saveSession(action.response.token)
      dispatch(redirectTo('DASHBOARD'))
    }
  }
)